<template>
  <div :class="['badge', { 'badge--active': isActive, 'badge--disabled': isDisabled }]" @click="handleClick">
    <span class="badge__title">
      {{ title }}
    </span>
  </div>
</template>

<script setup>

import { computed } from 'vue';

const props = defineProps({
  title: String,
  hour: String,
  avaiable: Number,
  selectedHour: String,
  width: {type:String, default:'80px'}
});

const isActive = computed(() => props.hour === props.selectedHour);
const isDisabled = computed(() => props.avaiable === 0);

const emit = defineEmits(['click']);

function handleClick() {
  if (!isDisabled.value) {
      emit('click');
  }
}

</script>

<style lang="scss">

@import '@/scss/mixings';

.badge {
  @include d-flex(column,center,center);
  width: v-bind(width);
  height: 35px;
  min-width: 80px;
  padding: 5px 12px;
  border-radius: 4px;
  border: 2px solid #066FCB;
  color: #066FCB;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; 
  cursor: pointer;
  &--active {
      border-color: #055398;
      background-color: #CEEBFB;
      color: #055EAC; 
  }
  &--disabled {
      border-color: #066FCB;
      opacity: 0.4;
  }
}

</style>
